import stbAPIGateway from '../../../../services/stbAPIGateway';
import {
  COMMON_SET_API_ERROR_MESSAGE,
  COMMON_SET_IS_RESPONSE_WITH_ERROR
} from '../../../mutationTypes';
import { EXCURSION_TYPE_MARKER, NOT_SUPPORTED_MARKER } from '../../../../lib/errorMessages';

export const fetchExcursionRiskCategories = async (
  { rootGetters, commit },
  { params, clientSid }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  try {
    const response = await stbApi.getExcursionRiskCategories(params, clientSid);
    if (response) {
      commit('setExcursionRiskCategoriesOptions', response);
    }
    return response;
  } catch (error) {
    const message = error?.response?.data?.message;
    if (
      typeof message === 'string' &&
      message.includes(EXCURSION_TYPE_MARKER) &&
      message.includes(NOT_SUPPORTED_MARKER)
    ) {
      commit(COMMON_SET_API_ERROR_MESSAGE, { message }, { root: true });
      commit(COMMON_SET_IS_RESPONSE_WITH_ERROR, true, { root: true });
    }
    throw error;
  }
};
